
import React, { useState, useEffect, useContext } from "react";
import ViewForm from "./ViewForm";
import { useParams } from 'react-router-dom'








const ViewPrivilegeForm = () => {
    const { id } = useParams()
    

    return (
        <div className="flex flex-col  max-w-[100vw] mx-auto  ">
            <ViewForm id={id} />
        </div>
    )
}



export default ViewPrivilegeForm;



